/* eslint-disable no-undef */
import Vue from 'vue'
import axios from 'axios'
import apis from '../api/apiHelper'
import delayLoad from '../utils/delayLoad'
let headerComps = null
let user = null
let layoutLoaded = false
let layoutVersionPromise = null
/**
 * 动态获取 eqx.layout 版本号，结果缓存避免重复请求
 */
function getLayoutVersion () {
  if (layoutVersionPromise) return layoutVersionPromise
  layoutVersionPromise = axios.get(apis.getEqxLayoutVersion)
    .then(res => {
      const version = res && res.data && (res.data.obj || (res.data.map && res.data.map.obj))
      if (!version) throw new Error('eqx.layout version missing')
      return version
    })
  return layoutVersionPromise
}
async function loadLayout () {
  if (layoutLoaded) return true
  const hostLayout = Vue.env.host.layout.replace(/https?:/, '')
  const version = await getLayoutVersion().catch(err => err && console.error(err))
  if (!version) return false
  const file = `eqx.layout/${version}/eqx.layout.min`
  return delayLoad.delayLoadJS(Vue.env.plugin.jquery)
    .then(() => Promise.all([
      delayLoad.delayLoadCSS(`${hostLayout}/${file}.css`),
      delayLoad.delayLoadJS(`${hostLayout}/${file}.js`)
    ]))
    .then(() => {
      layoutLoaded = true
      return true
    })
    .catch(err => err && console.error(err))
}
// eslint-disable-next-line no-unused-vars
function eqxLayoutShowAuth (opts, reset = false) {
  if (!headerComps) return Promise.reject(new Error())
  return headerComps.showAuth(opts).then(
    res => {
      if (res && (res.type === 'login' || res.type === 'register') && !reset) {
        window.location.reload()
        return false
      }
      if (res && res.type === 'close') {
        return Promise.reject(new Error())
      }
      return Vue.user.auth()
        .then((res2) => {
          // 注册成功后，可能需要区别做一些事情
          return initEqxLayout(res2.obj, reset, res.type === 'register')
        })
        .catch(() => {
          initEqxLayout(null, reset)
          return Promise.reject(new Error())
        })
    },
    data => Promise.reject(data)
  )
}
function initEqxLayout (userInfo, reset = false, isRegister) {
  if (reset) removeLayoutForUpdate()
  return loadLayout().then(res => {
    user = userInfo
    const eqxLayout = new EqxLayout({
      root: 'app',
      user: userInfo || {}
    })
    headerComps = eqxLayout
      .render('header', {
        activeTab: '免费模板',
        backeip: true,
        showSearch: true,
        searchFixed: true
      })
      .setLogin(() => {
        eqxLayoutShowAuth({ type: 'login' })
      })
      .setRegister(() => {
        eqxLayoutShowAuth({ type: 'register' })
      })
    // 暂时不开发右侧导航
    // eqxLayout.render('block', {})
    eqxLayout.render('footer', {
      center: true
    })
    return Promise.resolve(isRegister)
  }).catch((e) => {
    return Promise.reject(new Error(e))
  })
}

/**
 * 清除Layout渲染的Header和Footer
 *
 */
function removeLayoutForUpdate () {
  const $header = document.querySelector('.eqx-header')
  const $footer = document.querySelector('.eqx-footer')
  $header && $header.remove()
  $footer && $footer.remove()
}

function showLogin ({ reset = false } = {}) {
  if (user) return Promise.resolve(false)
  return eqxLayoutShowAuth({ type: 'login' }, reset)
}
function cornerHandler () {
  return false
}
const common = {
  install (Vue) {
    Vue.layout = Vue.prototype.layout = {
      initEqxLayout,
      showLogin,
      cornerHandler,
      eqxLayoutShowAuth
    }
  }
}

Vue.use(common)
